function portailService(WCConstants, $http, $translate, authService) {
    var vm = this;

    vm.getURL = function (authInfos) {
        var storeId = authInfos && authInfos.data.data ? authInfos.data.data.storeId : null;

        return $http
            .get('param://urls/' + storeId)
            .then(function (res) {
                vm.cards
                    .filter(function (card) {
                        return card.param;
                    })
                    .map(function (card) {
                        if (card.param === 'productWalnut') {
                            card.url = res.data[card.param]
                                .toString()
                                .replace('/serveurs/customers', WCConstants.appConfig.moduleURL);
                            card.url += 'orders/';
                        }
                        else if (card.param === '_product_catalog') {
                            card.url = WCConstants.appConfig.moduleURL + res.data[card.param].toString() + 'menus';
                        }
                        else if (card.param === 'tutoWalnut') {
                            card.url = WCConstants.appConfig.moduleURL.toString();
                            if (authInfos.data.data.module_boulangerie === 1) {
                                card.url = res.data['_tuto_bakery']
                                    .toString()
                                    .replace('/serveurs/customers', WCConstants.appConfig.moduleURL);
                            }
                            else if (authInfos.data.data.module_fleuriste === 1) {
                                card.url = res.data['_tuto_florist']
                                    .toString()
                                    .replace('/serveurs/customers', WCConstants.appConfig.moduleURL);
                            }
                            else if (authInfos.data.data.module_seddif === 1) {
                                card.url = res.data['_tuto_nap']
                                    .toString()
                                    .replace('/serveurs/customers', WCConstants.appConfig.moduleURL);
                            }
                            else {
                                card.url = res.data['_tuto_other']
                                    .toString()
                                    .replace('/serveurs/customers', WCConstants.appConfig.moduleURL);
                            }
                        }
                        else {
                            card.url = res.data[card.param]
                                .toString()
                                .replace('/serveurs/customers', WCConstants.appConfig.moduleURL);
                        }
                    });
            })
            .catch(function () {
                return false;
            });
    };

    vm.cards = [
        {
            name    : 'tabac',
            params  : ['module_tabac'],
            services: [],
            class   : 'card-tobacco',
            icon    : 'https://icons.bimedia-it.com/icons/walnut/tobacco2.svg',
            label   : $translate.instant('CARD.TOBACCO_LABEL'),
            param   : 'tobaccoWalnut',
            active  : false,
            native  : true,
            roles   : ['OWNER']
        },
        {
            name    : 'produits',
            params  : ['module_produits'],
            services: [],
            class   : 'card-product',
            icon    : 'https://icons.bimedia-it.com/icons/streamlineIcons_3.0/Streamline-Ultimate-Regular/09-Shopping-Ecommerce/06-Tags%3ACodes/barcode.svg',
            label   : $translate.instant('CARD.PRODUCTS_LABEL'),
            param   : 'productWalnut',
            active  : true,
            native  : true,
            roles   : ['OWNER']
        },
        {
            name    : 'librairie',
            params  : ['module_librairie'],
            services: [],
            class   : 'card-bookstore',
            icon    : 'https://icons.bimedia-it.com/icons/streamlineIcons_3.0/Streamline-Ultimate-Regular/11-Content/02-Books/book-open-text.svg', // https://icons.bimedia-it.com/icons/walnut/books.svg
            label   : $translate.instant('CARD.BOOKSTORE_LABEL'),
            param   : 'bookstoreWalnut',
            active  : false,
            native  : true,
            roles   : ['OWNER']
        },
        {
            name    : 'tickets restaurant',
            params  : ['module_boulangerie'],
            services: [],
            class   : 'card-lunchvoucher',
            icon    : 'https://icons.bimedia-it.com/icons/streamlineIcons_3.0/Streamline-Ultimate-Regular/26-Food-Drinks/01-Eating-Restaurant/restaurant-eating-set.svg',
            label   : $translate.instant('CARD.TR_LABEL'),
            param   : 'trWalnut',
            active  : false,
            native  : true,
            roles   : ['OWNER']
        },
        {
            name    : 'commande client',
            params  : ['module_boulangerie', 'module_fleuriste'],
            services: [],
            class   : 'card-bakery',
            icon    : 'https://icons.bimedia-it.com/icons/streamlineIcons_3.0/Streamline-Ultimate-Regular/10-Shipping-Delivery/01-Warehouse%3AFullfilment/warehouse-package-box.svg',
            label   : $translate.instant('CARD.CUSTOMER_ORDER_LABEL'),
            param   : 'bakeryBookingWalnut',
            active  : false,
            native  : true,
            roles   : ['OWNER']
        },
        {
            name    : 'Transmission Florale',
            params  : ['module_fleuriste'],
            services: [],
            class   : 'card-transmission',
            icon    : 'https://icons.bimedia-it.com/icons/streamlineIcons_3.0/Streamline-Ultimate-Light/32-Nature-Farming/07-Flowers/flower.svg',
            label   : $translate.instant('CARD.TRANSMISSION_LABEL'),
            param   : 'ServiceFlorajet',
            active  : false,
            native  : true,
            roles   : ['OWNER']
        },
        {
            name    : 'dashboard',
            params  : ['module_dashboard'],
            services: [],
            class   : 'card-dashboard',
            // les icônes sont en ligne sur le serveur ici : https://customers-is-hor-p-gra5-01.bimedia-it.com/streamlineIcons/3.0/Streamline-Ultimate-Regular/06-%20SVG/
            icon    : 'https://icons.bimedia-it.com/icons/streamlineIcons_3.0/Streamline-Ultimate-Regular/06-Business-Products/12-Analytics/analytics-bars.svg',
            // https://icons.bimedia-it.com/icons/streamlineIcons_3.0/Streamline-Ultimate-Regular/01-Interface Essential/02-Dashboard/pie-line-graph.svg',
            // https://icons.bimedia-it.com/icons/walnut/graph-line.svg
            label   : $translate.instant('CARD.DASHBOARD_LABEL'),
            param   : 'dashboardWalnut',
            active  : true,
            native  : true,
            roles   : ['OWNER', 'ACCOUNTANT']
        },
        {
            name    : 'bimediaoffice',
            params  : ['module_office'],
            services: [],
            class   : 'card-bimediaoffice',
            icon    : 'https://icons.bimedia-it.com/icons/streamlineIcons_3.0/Streamline-Ultimate-Regular/01-Interface%20Essential/41-Hierachy%3AOrganization/hierarchy-7.svg',
            label   : $translate.instant('CARD.BIMOFFICE_LABEL'),
            url     : 'http://bimediaoffice.fr/',
            active  : true,
            native  : true,
            roles   : ['OWNER', 'ACCOUNTANT']
        },
        {
            name    : 'eshop',
            params  : ['module_tabac', 'module_presse'],
            services: [],
            class   : 'card-eshop',
            icon    : 'https://icons.bimedia-it.com/icons/streamlineIcons_3.0/Streamline-Ultimate-Regular/09-Shopping-Ecommerce/01-Shops/shop-cart.svg', // https://icons.bimedia-it.com/icons/walnut/cash-input.svg
            label   : $translate.instant('CARD.ESHOP_LABEL'),
            url     : WCConstants.appConfig.moduleURL + '/auth-services-tiers/',
            active  : false,
            native  : true,
            roles   : ['OWNER']
        },
        {
            name    : 'Espace client',
            params  : ['module_compteespaceclient'],
            services: [],
            class   : 'card-myAccount',
            icon    : 'https://icons.bimedia-it.com/icons/streamlineIcons_3.0/Streamline-Ultimate-Regular/17-Users/03-Geometric-Full Body-Man/single-man-setting.svg',
            label   : $translate.instant('CARD.CUSTOMER_MYACCOUNT_LABEL'),
            param   : 'myaccountWalnut',
            active  : true,
            native  : true,
            roles   : ['OWNER', 'ACCOUNTANT']
        },
        {
            name    : 'bimediatv',
            params  : ['module_tv'],
            services: [],
            class   : 'card-bimediatv',
            icon    : 'https://icons.bimedia-it.com/icons/streamlineIcons_3.0/Streamline-Ultimate-Regular/03-Computers-Devices-Electronics/02-Desktop-Computers/monitor-1.svg',
            label   : $translate.instant('CARD.BIMEDIATV_LABEL'),
            url     : 'https://votre-espace.bimediatv.com/',
            active  : true,
            native  : true,
            roles   : ['OWNER']
        },
        // {
        //     name    : 'Google My Business',
        //     params  : [],
        //     services: ['BOOST'],
        //     class   : 'card-googleMyBusiness',
        //     icon    : 'https://icons.bimedia-it.com/icons/walnut/google_my_business.svg', // https://icons.bimedia-it.com/icons/logosPartenaires/gmb.svg
        //     label   : $translate.instant('CARD.GMB_LABEL'),
        //     url     : 'https://www.google.com/intl/fr_fr/business/',
        //     active  : false,
        //     native  : true,
        //     roles   : ['OWNER']
        // },
        {
            name    : 'Clients & Fidélité',
            params  : [],
            services: ['BOOST', 'MPDVC'],
            class   : 'card-clientsFid',
            icon    : 'https://icons.bimedia-it.com/icons/streamlineIcons_3.0/Streamline-Ultimate-Regular/22-Social-Medias-Rewards-Rating/06-Rating/rating-star.svg',
            label   : $translate.instant('CARD.CONSUMERS_LABEL'),
            param   : '_consumers_front',
            active  : false,
            native  : true,
            roles   : ['OWNER']
        },
        {
            name    : 'Produits multi-pdv',
            params  : [],
            services: ['MPDVP'],
            class   : 'card-mpdv',
            icon    : 'https://icons.bimedia-it.com/icons/streamlineIcons_3.0/Streamline-Ultimate-Regular/16-Files-Folders/02-Folders/folder-share.svg',
            label   : $translate.instant('CARD.CHAINSTORE_PRODUCTS_LABEL'),
            param   : '_chainstore_products_front',
            active  : false,
            native  : true,
            roles   : ['OWNER']
        },
        {
            name    : 'Gestion des menus',
            params  : ['module_restauration'],
            services: [],
            class   : 'card-menus',
            icon    : 'https://icons.bimedia-it.com/icons/streamlineIcons_3.0/Streamline-Ultimate-Regular/26-Food-Drinks/01-Eating-Restaurant/restaurant-menu.svg',
            label   : $translate.instant('CARD.MANAGE_MENU_LABEL'),
            param   : '_product_catalog',
            active  : false,
            native  : true,
            roles   : ['OWNER']
        },
        {
            name    : 'Documentation',
            params  : [],
            services: [],
            class   : 'card-documentation',
            icon    : 'https://icons.bimedia-it.com/icons/streamlineIcons_3.0/Streamline-Ultimate-Regular/36-School-Learning/04-Library%3AReading/read-light-idea.svg',
            label   : $translate.instant('CARD.DOCUMENTATIONS_LABEL'),
            state   : 'documentation',
            active  : true,
            native  : true
        },
        {
            name    : 'Nap',
            params  : ['module_seddif'],
            services: [],
            class   : 'card-nap',
            icon    : 'https://icons.bimedia-it.com/icons/streamlineIcons_3.0/Streamline-Ultimate-Regular/36-School-Learning/04-Library%3AReading/read-light-idea.svg',
            label   : $translate.instant('CARD.NAP_LABEL'),
            state   : 'nap',
            active  : false,
            native  : true,
            roles   : ['OWNER', 'OPERATOR', 'MANAGER']
        },
        {
            name    : 'Espace PRO Nap',
            params  : ['module_seddif'],
            services: [],
            class   : 'card-espace-nap',
            icon    : 'https://icons.bimedia-it.com/icons/logosPartenaires/LOGO_ESPACE_PRO_NAP.svg',
            label   : $translate.instant('CARD.NAP_ESPACE_PRO_LABEL'),
            state   : 'espace_nap',
            url     : 'https://extranet.groupe-nap.com',
            active  : false,
            native  : true,
            roles   : ['OWNER', 'OPERATOR', 'MANAGER']
        },
        {
            name    : 'Agenda',
            params  : [],
            services: [],
            class   : 'card-calendar',
            icon    : 'https://icons.bimedia-it.com/icons/streamlineIcons_3.0/Streamline-Ultimate-Regular/01-Interface Essential/21-Date%3ACalendar/calendar-3.svg',
            label   : $translate.instant('CARD.CALENDAR_LABEL'),
            param   : '_widget_calendar',
            active  : true,
            native  : true,
            roles   : ['OWNER', 'OPERATOR', 'MANAGER']
        },
        {
            name    : 'Bloc-notes',
            params  : [],
            services: [],
            class   : 'card-notes',
            icon    : 'https://icons.bimedia-it.com/icons/streamlineIcons_3.0/Streamline-Ultimate-Regular/11-Content/03-Notes/notes-paper-text.svg',
            label   : $translate.instant('CARD.NOTES_LABEL'),
            param   : '_widget_notes',
            active  : true,
            native  : true,
            roles   : ['OWNER', 'OPERATOR', 'MANAGER']
        },
        {
            name    : 'Portail Nepting',
            params  : [],
            services: [],
            class   : 'card-nepting',
            icon    : 'https://icons.bimedia-it.com/icons/logosPartenaires/LOGO_NEPTING.svg',
            label   : $translate.instant('CARD.NEPTING_LABEL'),
            url     : 'https://nepsa1.nepting.com/alladmin/#MainPlace:default',
            active  : true,
            native  : true,
            roles   : ['OWNER', 'OPERATOR', 'MANAGER']
        },
        {
            name    : 'Transactions financées',
            params  : [],
            services: ['BPAY'],
            class   : 'card-transFinancees',
            icon    : 'https://icons.bimedia-it.com/icons/logosPartenaires/logo_BPAY.svg',
            label   : $translate.instant('CARD.BIMEDIAPAY_FINANCIAL__LABEL'),
            param   : '_bimedia_pay_financial',
            active  : false,
            native  : true,
            roles   : ['OWNER', 'MANAGER']
        },
        {
            name    : 'Transactions Temps réels',
            params  : [],
            services: ['BPAY'],
            class   : 'card-transTempsReels',
            icon    : 'https://icons.bimedia-it.com/icons/logosPartenaires/logo_BPAY.svg',
            label   : $translate.instant('CARD.BIMEDIAPAY_REALTIME_LABEL'),
            param   : '_bimedia_pay_realtime',
            active  : false,
            native  : true,
            roles   : ['OWNER', 'MANAGER']
        },
        {
            name    : 'Google My Business',
            params  : [],
            services: ['BOOST'],
            class   : 'card-googleMyBusiness',
            icon    : 'https://icons.bimedia-it.com/icons/logosPartenaires/gmb-logo_200x100.jpg',
            label   : $translate.instant('CARD.FDJ_LABEL'),
            url     : 'https://www.google.com/intl/fr_fr/business/',
            active  : false,
            // native  : true,
            native  : false,
            roles   : ['OWNER']
        },
        {
            name    : 'fdj',
            params  : ['module_tabac', 'module_presse'],
            services: [],
            class   : 'card-fdj',
            icon    : 'https://icons.bimedia-it.com/icons/logosPartenaires/fdj-logo_200x100.jpg',
            label   : $translate.instant('CARD.FDJ_LABEL'),
            url     : 'https://csam-sso.lfdj.com/user/auth',
            active  : false,
            native  : false,
            roles   : ['OWNER', 'OPERATOR', 'MANAGER']
        },
        {
            name    : 'pmu',
            params  : ['module_tabac', 'module_presse'],
            services: [],
            class   : 'card-pmu',
            icon    : 'https://icons.bimedia-it.com/icons/logosPartenaires/pmu-logo_200x100.jpg',
            label   : $translate.instant('CARD.PMU_LABEL'),
            url     : 'https://auth.partenaires.pmu.fr/?callbackUrl=https://espacegestion.partenaires.pmu.fr/api/partner_portal',
            active  : false,
            native  : false,
            roles   : ['OWNER', 'OPERATOR', 'MANAGER']
        },
        {
            name    : 'france messagerie',
            params  : ['module_presse'],
            services: [],
            class   : 'card-franceMessagerie',
            icon    : 'https://icons.bimedia-it.com/icons/logosPartenaires/france-messagerie.png',
            label   : $translate.instant('CARD.FRANCEMESSAGERIE_LABEL'),
            url     : 'https://www.francemessagerie.fr/',
            active  : false,
            native  : false,
            roles   : ['OWNER', 'OPERATOR', 'MANAGER']
        },
        {
            name    : 'mlp',
            params  : ['module_presse'],
            services: [],
            class   : 'card-mlp',
            icon    : 'https://icons.bimedia-it.com/icons/logosPartenaires/mlp-logo_200x100.jpg',
            label   : $translate.instant('CARD.MLP_LABEL'),
            url     : 'https://omega.mlp.fr/',
            active  : false,
            native  : false,
            roles   : ['OWNER', 'OPERATOR', 'MANAGER']
        },
        {
            name    : 'directreseau',
            params  : ['module_presse'],
            services: [],
            class   : 'card-directreseau',
            icon    : 'https://icons.bimedia-it.com/icons/logosPartenaires/direct-reseau-logo_200x100.jpg',
            label   : $translate.instant('CARD.DIRECTRESEAU_LABEL'),
            url     : 'https://www.direct-reseau.fr/login',
            active  : false,
            native  : false,
            roles   : ['OWNER', 'OPERATOR', 'MANAGER']
        },
        {
            name    : 'la poste',
            params  : ['module_tabac', 'module_presse'],
            services: [],
            class   : 'card-laPoste',
            icon    : 'https://icons.bimedia-it.com/icons/logosPartenaires/laposte-logo_200x100.jpg',
            label   : $translate.instant('CARD.LAPOSTE_LABEL'),
            url     : 'https://www.laposte.fr/professionnel/timbres-marianne/c/312?xtor=SEC-400000100-GOO-[Marque+Exact+La+Poste]-[344278798502]-S-[la%20poste%20professionnel]&compte=Marque&&gclid=EAIaIQobChMIiJ7B-Nei5AIVhbHtCh19mg9gEAAYASADEgIr9PD_BwE',
            active  : false,
            native  : false,
            roles   : ['OWNER', 'OPERATOR', 'MANAGER']
        },
        {
            name    : 'dilicom',
            params  : ['module_librairie'],
            services: [],
            class   : 'card-dilicom',
            icon    : 'https://icons.bimedia-it.com/icons/logosPartenaires/dilicom-logo_200x100.jpg',
            label   : $translate.instant('CARD.DILICOM_LABEL'),
            url     : 'https://dilicom-prod.centprod.com/index.html',
            active  : false,
            native  : false,
            roles   : ['OWNER', 'OPERATOR', 'MANAGER']
        },
        {
            name    : 'hachette',
            params  : ['module_librairie'],
            services: [],
            class   : 'card-hachette',
            icon    : 'https://icons.bimedia-it.com/icons/logosPartenaires/hachette-livre-logo_200x100.jpg',
            label   : $translate.instant('CARD.HACHETTE_LABEL'),
            url     : 'https://www.hachette-diffusion.fr/portailcommercial/portailcommercial/index.jsp',
            active  : false,
            native  : false,
            roles   : ['OWNER', 'OPERATOR', 'MANAGER']
        },
        {
            name    : 'interforum',
            params  : ['module_librairie'],
            services: [],
            class   : 'card-interforum',
            icon    : 'https://icons.bimedia-it.com/icons/logosPartenaires/interforum-logo_200x100.jpg',
            label   : $translate.instant('CARD.INTERFORUM_LABEL'),
            url     : 'https://www.interforum.fr/login_init.do',
            active  : false,
            native  : false,
            roles   : ['OWNER', 'OPERATOR', 'MANAGER']
        },
        {
            name    : 'florajet',
            params  : ['module_fleuriste'],
            services: [],
            class   : 'card-florajet',
            icon    : 'https://icons.bimedia-it.com/icons/logosPartenaires/monFlorajet-logo_200x100.jpg',
            label   : $translate.instant('CARD.MONFLORAJET_LABEL'),
            url     : 'https://v3.monflorajet.com/',
            active  : false,
            native  : false,
            roles   : ['OWNER', 'OPERATOR', 'MANAGER']
        },
        {
            name    : 'media diffusion',
            params  : ['module_librairie'],
            services: [],
            class   : 'card-mediaDiffusion',
            icon    : 'https://icons.bimedia-it.com/icons/logosPartenaires/media-diffusion-logo_200x100.png',
            label   : $translate.instant('CARD.MEDIADIFFUSION_LABEL'),
            url     : 'https://groupemediadiffusion.centprod.com/nos_editeurs.html?noTicket=true',
            active  : false,
            native  : false,
            roles   : ['OWNER', 'OPERATOR', 'MANAGER']
        },
        {
            name    : 'tutoriels',
            params  : ['module_librairie'],
            services: [],
            class   : 'card-tutos',
            icon    : 'https://icons.bimedia-it.com/icons/streamlineIcons_3.0/Streamline-Ultimate-Regular/01-Interface Essential/14-Alerts/question-circle.svg',
            label   : $translate.instant('CARD.TUTOS_LABEL'),
            param   : 'tutoWalnut',
            active  : true,
            native  : true
        }
    ];

    vm.getCards = function () {
        let authInfos = authService.getAuthInfos();
        return vm.getURL(authInfos).then(function () {
            return vm.cards.filter((card) => {
                return !card.roles || authService.isUserInRoles(card.roles);
            });
        });
    };

    return vm;
}

angular.module('app.portail.common').factory('portailService', portailService);
